// packages/main/app/web/components-v2/UnifiedImageDialog/styles.ts
import { StyleSheet } from 'aphrodite';
import { THEME } from '../../Theme/theme';

export const styleSheet = StyleSheet.create({
	bulkRebrandingHeader: {
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.bold,
		marginBottom: THEME.spacing.md,
		borderBottom: `1px solid ${THEME.colors.border.light}`,
	},
	imageSelectionContainer: {
		flexGrow: 0,
	},
	imagesSelectionList: {
		marginTop: THEME.spacing.md,
		display: 'flex',
		flexDirection: 'row',
		gap: THEME.spacing.md,
	},
	imageSelectionItem: {
		width: 120,
	},
	imageSelectionItemImage: {
		height: 120,
		width: 120,
		objectFit: 'cover',
		borderRadius: THEME.common.borderRadius,
	},
	resultContainer: {
		marginTop: THEME.spacing.md,
		borderTop: `1px solid ${THEME.colors.border.light}`,
		paddingTop: THEME.spacing.md,
		flex: 1,
		overflow: 'auto',
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
	},
	bulkRebrandingContainer: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
	},
	imageContainer: {
		height: 'auto',
		width: 120,
		objectFit: 'cover',
		overflow: 'hidden',
		cursor: 'pointer',
		transition: 'all 0.2s',
		':hover': {
			transform: 'scale(1.02)',
		},
	},
	image: {
		width: 120,
		height: 120,
		borderRadius: THEME.common.borderRadius,
		objectFit: 'cover',
	},
	checkboxLabel: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		fontSize: THEME.typography.fontSizes.xs,
	},
	imageRow: {
		display: 'flex',
		flexDirection: 'row',
		gap: THEME.spacing.md,
		borderBottom: `1px solid ${THEME.colors.border.light}`,
		paddingBottom: THEME.spacing.md,
	},
	resultImageContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		alignItems: 'center',
	},
	resultImageLabel: {
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.bold,
	},
	resultImageLabelOriginal: {
		color: THEME.colors.text.light,
	},
	modalActionsContainer: {
		display: 'flex',
		justifyContent: 'flex-start',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		paddingTop: THEME.spacing.md,
	},
	actionsContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		height: 120,
		borderRadius: THEME.common.borderRadius,
		boxSizing: 'border-box',
		padding: THEME.spacing.md,
	},
	failedImagesText: {
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.danger.main,
	},
	brandingActionRow: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
	},
	brandingProgressStatus: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
	},
});
